import React from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { trademarkPricingTiers } from '../data/competitivePricing';

export const Pricing = ({ onOpenForm }) => {
  const pricingPlans = trademarkPricingTiers;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wider">Pricing Plans</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F44] mt-4 mb-6">
            Transparent Pricing for Every Stage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the perfect plan to protect your intellectual property. No hidden fees, no surprises — just expert legal protection.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative bg-white rounded-2xl p-6 transition-all duration-300 flex flex-col ${
                plan.popular
                  ? 'border-4 border-[#D4AF37] shadow-2xl transform lg:-translate-y-4'
                  : 'border-2 border-gray-200 shadow-lg hover:shadow-2xl hover:-translate-y-2'
              }`}
            >
              {/* Popular Badge */}
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-[#D4AF37] text-[#0A1F44] px-4 py-1 rounded-full font-bold text-sm flex items-center space-x-1 whitespace-nowrap">
                    <Star className="w-4 h-4 fill-current" />
                    <span>MOST POPULAR</span>
                  </div>
                </div>
              )}

              {/* Plan Header */}
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#0A1F44] mb-2">{plan.name}</h3>
                <div className="mb-2">
                  {plan.wasPrice && (
                    <div className="text-lg text-gray-400 line-through mb-1">{plan.wasPrice}</div>
                  )}
                  <span className="text-4xl font-bold text-[#0A1F44]">{plan.price}</span>
                </div>
                {plan.priceNote && (
                  <p className="text-xs text-gray-500 mb-2">{plan.priceNote}</p>
                )}
                <p className="text-gray-600 text-sm">{plan.description}</p>
              </div>

              {/* Features List */}
              <ul className="space-y-4 mb-6 flex-grow">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-5 h-5 bg-[#D4AF37] rounded-full flex items-center justify-center mt-0.5">
                      <Check className="w-3 h-3 text-[#0A1F44]" />
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button - Aligned to bottom */}
              <Button
                onClick={onOpenForm}
                className={`w-full font-bold py-6 text-lg transition-all duration-300 mt-auto ${
                  plan.popular
                    ? 'liquid bg-[#D4AF37] text-[#0A1F44] hover:bg-[#B8941F]'
                    : 'liquid-outline bg-transparent text-[#0A1F44] border-2 border-[#0A1F44] hover:bg-[#0A1F44] hover:text-white'
                }`}
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            All plans include government filing fees. Need a custom solution?{' '}
            <a href="/contact" className="text-[#D4AF37] font-semibold hover:text-[#B8941F] transition-colors">
              Contact us for a personalized quote
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};